<div class="container company-profile-page" style="margin-top: 10px;background-color: #fff;margin-left: 0px;">
    <div class="row facility-info">
        <div class="col" style="margin-left: 15px;margin-top: 20px;margin-right: 15px;">
            <div class="company-profile-hero" style="background-color: #DFF5F2;">
              <div class="row facility-header-row">

                <div class="col-md-6 facility-name-container">
                  <h1 style="margin-left:15px; margin-top:30px;color:#14274e;font-size:32px;">
                    {{tenantDetails?.tenantName}}
                  </h1>
                </div>

                <div class="col-md-6 facility-header-image-container">
                  <img
                    [src]="getImageToShowInTenantDetailsHeader()"
                    class="facility-header-image">
                </div>

              </div>
              <!--<div class="row facility-header-row">
                <div class="col" style="margin-left: 36px;">
                  <h1 style="margin-top: 30px;color: #14274e;font-size: 32px;">
                      {{tenantDetails?.tenantName}}
                  </h1>
                  &lt;!&ndash;<p style="color: #14274e;">
                      {{tenantDetails?.description}}
                  </p>&ndash;&gt;
                  &lt;!&ndash;<div
                    style="color: #14274e;"
                    [innerHTML]="tenantDetails?.description">
                  </div>&ndash;&gt;
                </div>
                <div class="col facility-header-image-container">
                  <img
                    [src]="getImageToShowInTenantDetailsHeader()"
                    class="facility-header-image" />
                </div>
              </div>-->
              <div *ngIf="showFacilityFeatures" class="overlay" (click)="onClickEditIcon()">
                  <div class="hover-icon-with-edit-text">
                      <div>
                          <img src="../../assets/img/iconfinder_Pen_728966.svg" style="width: 30px; height: 30px;">
                      </div>
                      <div>
                          EDIT
                      </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
    <div *ngIf="showFacilityFeatures" class="row company-profile-content">
        <div class="col" style="margin-left: 15px;">
            <div>
                <p class="admin-string-primary" style="margin-top: 15px;">
                    FACILITY FEATURES
                </p>
                <hr style="background-color: #D8DFE6;" />
                <p class="admin-string-secondary">
                    AMENITIES
                </p>
                <div style="margin-bottom: 10px;">
                    <mat-chip-list aria-label="Amenities" >
                        <mat-chip class="company-profile-chip" style="border-radius: 4px; background-color: #DDE4E9; font: normal normal normal 12px/17px OpenSans-R; color: #333333;margin-right: 10px;"
                            *ngFor="let amenity of amenities"
                            [removable]="removable"
                            (removed)="deleteAmenity(amenity)" >
                            {{amenity.amenityName}}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                </div>
                <div>
                    <div *ngIf="showAddNewAmenitiesButton">
                        <button class="btn btn-primary admin-button" type="button" (click)="clickedAddNewAmenitiesButton()" >
                            Add New
                        </button>
                    </div>
                    <div *ngIf="!showAddNewAmenitiesButton">
                        <form [formGroup]="amenityFormGroup">
                            <p style="font-size: 14px;">
                                Add Your Own
                                <input type="text" formControlName="amenityNameFormControl" style="margin-left: 30px; width: 200px;/*border-top: none;*//*border-right: none;*//*border-left: none;*/outline: 0;border: none;border-bottom: 1px solid black;" />
                                <button class="btn btn-primary save-button" type="button" [disabled]="amenityFormGroup.invalid" (click)="createNewAmenity()" >
                                    Save
                                </button>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
            <div style="margin-top: 40px;">
                <p class="admin-string-primary">
                    HOLIDAYS
                </p>
                <hr style="background-color: #D8DFE6;" />
                <p class = "admin-string-secondary">
                    YEARLY HOLIDAYS
                </p>
                <div style="margin-bottom: 10px;">
                    <mat-chip-list aria-label="Holidays">
                        <mat-chip class="company-profile-chip" style="border-radius: 4px; background-color: #DDE4E9;font: normal normal normal 12px/17px OpenSans-R; color: #333333; margin-right: 10px;"
                            *ngFor="let holiday of holidays"
                            [removable]="removable"
                            (removed)="deleteHoliday(holiday)">
                            {{holiday.displayDate}}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                </div>
                <div>
                    <div *ngIf="showAddNewHolidaysButton">
                        <button class="btn btn-primary admin-button" type="button" (click)="clickedAddNewHolidaysButton()">
                            Add New
                        </button>
                    </div>
                    <div *ngIf="!showAddNewHolidaysButton">
                        <form [formGroup]="holidayFormGroup">
                            <p style="font-size: 14px;">
                                Add Your Own
                                <input type="text" [matDatepicker]="picker" formControlName="holidayFormControl" style="margin-left: 30px;/*border-top: none;*//*border-right: none;*//*border-left: none;*/outline: 0;border: none;border-bottom: 1px solid black;" />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <button class="btn btn-primary save-button" type="button" [disabled]="holidayFormGroup.invalid" (click)="createNewHoliday()">
                                    Save
                                </button>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
            <div style="margin-top: 40px;">

                <p class="admin-string-primary">
                    GOOGLE MAP LINK
                </p>
                <hr style="background-color: #D8DFE6;" />
                <div>
                        <form [formGroup]="googleMapsLinkFormGroup">
                            <p class="google-map-form-row" style="font-size: 14px;">
                                <input type="text" formControlName="googleMapsLinkFormControl" style="/*border-top: none;*//*border-right: none;*//*border-left: none;*/outline: 0;border: none;border-bottom: 1px solid black;width: 750px;" />
                                <button class="btn btn-primary save-button" type="button" [disabled]="googleMapsLinkFormGroup.invalid" (click)="updateGoogleMapsLink()">
                                    Save
                                </button>
                            </p>
                        </form>
                </div>
            </div>
            <div style="margin-top: 40px;">
                <p class="admin-string-primary">
                    RULES
                    <mat-icon *ngIf="!ruleEditMode" title="Edit Rules" class="rule-icon" (click)="toggleEditRule()">edit</mat-icon>
                    <mat-icon *ngIf="ruleEditMode" title="Update Rules" class="rule-icon" (click)="updateRules()">save</mat-icon>
                    <mat-icon *ngIf="ruleEditMode" title="Cancel" class="rule-icon" (click)="toggleEditRule()">cancel</mat-icon>
                </p>
                <hr style="background-color: #D8DFE6;" />
                <div style="margin-bottom: 10px;">
                    <div *ngIf="!ruleEditMode" >
                        <div class="rules-list">
                            <div class="rule-display-row hover-container" *ngFor="let rule of rules; let i = index">
                                <mat-icon class="rule-icon rule-delete-icon" (click)="deleteRuleConfirm(rule.id)">delete</mat-icon>
                                <span class="rule-number-badge">{{i + 1}}</span>
                                <span class="rule-display-text">{{rule.description}}</span>
                            </div>
                        </div>
                        <div class="popup-overlay" *ngIf="showPopup">
                            <div class="confirmation-popup">
                              <p>Are you sure you want to delete the rule?</p>
                              <button (click)="confirmDelete()">Yes</button>
                              <button (click)="cancelPopup()">No</button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="ruleEditMode" >
                        <div class="rule-edit-row" *ngFor="let rule of rules; let i = index">
                            <span class="rule-number-badge">{{i + 1}}</span>
                            <input type="text" class="rule-text rule-edit-input" style="margin-left: 30px;/*border-top: none;*//*border-right: none;*//*border-left: none;*/outline: 0;border: none;border-bottom: 1px solid black;width: 750px;" [(ngModel)]="rule.description" />
                        </div>
                    </div>
                </div>
                <div>
                    <div *ngIf="showAddNewRulesButton">
                        <button class="btn btn-primary admin-button" type="button" (click)="clickedAddNewRulesButton()" *ngIf="!ruleEditMode">
                            Add New
                        </button>
                    </div>
                    <div *ngIf="!showAddNewRulesButton">
                        <form [formGroup]="ruleFormGroup">
                            <p class="rule-add-row" style="font-size: 14px;">
                                <span class="rule-number-badge">{{rules.length + 1}}</span><input type="text" class="rule-edit-input" formControlName="ruleFormControl" style="margin-left: 30px;/*border-top: none;*//*border-right: none;*//*border-left: none;*/outline: 0;border: none;border-bottom: 1px solid black;width: 750px;" />
                                <button class="btn btn-primary save-button" type="button" [disabled]="ruleFormGroup.invalid" (click)="createNewRule(rules.length + 1)" style="margin-left: 30px;width: 42px;height: 24px;font-size: 12px;color: #7c7575;background-color: #dde4e9;padding: 0px;">
                                    Save
                                </button>
                                <mat-icon title="Cancel" class="rule-icon" style="margin-left: 10px;" (click)="cancelSave()">cancel</mat-icon>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!showFacilityFeatures" class="row company-profile-content">
        <div class="col" style="margin-left: 15px;">
            <form [formGroup]="facilityDetailsFormGroup">
                <div class="form-group">
                    <div>
                        <p class="admin-string-primary" style="margin-top: 25px;">
                            FACILITY DETAILS
                            <button class="btn btn-primary" type="button" [disabled]="facilityDetailsFormGroup.invalid" (click)="onSaveClicked()" style="background-color: #ffffff;color: #14274E;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 30px;border-color: #14274E;">
                                Save
                            </button>
                            <button class="btn btn-primary" (click)="onCancelClick()" type="button" style="background-color: #ffffff;color: #14274e;width: 66px;height: 30px;padding: 0px;font-size: 14px;float: right;margin-right: 30px;border: none;">
                                Cancel
                            </button>
                        </p>
                        <hr style="background-color: #D8DFE6;" />
                    </div>
                    <div class="row">
                        <div class="col">
                            <div>
                                <div style="float: left;margin-right: 100px;">
                                    <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="facility-name">
                                        FACILITY NAME
                                    </label>
                                    <input type="text" id="facility-name" [(ngModel)]="tenantDetails.tenantName" formControlName="facilityNameFormControl" class="form-control" placeholder="Facility Name"
                                        style="width: 350px;height: 40px;" />
                                    <div *ngIf="facilityDetailsFormControls.facilityNameFormControl.hasError('required') && facilityDetailsFormControls.facilityNameFormControl.touched" style="color: red;font-size: 14px;">
                                        Facility Name is required.
                                    </div>
                                </div>
                                <div style="float: left;">
                                    <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="facility-type">
                                        FACILITY TYPE
                                    </label>
                                    <select [(ngModel)]="tenantDetails.tenantCategoryId" id="facility-type" class="form-control" formControlName="facilityTypeFormControl" (change)="selectValueChangeForFacilityType()" style="width: 350px;height: 40px;" required>
                                        <!-- <option value="" hidden>
                                                Facility Type
                                        </option> -->
                                        <option *ngFor="let facilityType of facilityTypes" [value]="facilityType.id">
                                                {{facilityType.tenantCategory}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                  <div class="row" style="margin-top:20px;">
                    <div class="col-12">
                      <label
                        style="font-size:11px;
                               color:#7c7575;
                               font-weight:bold;">
                        FACILITY DESCRIPTION
                      </label>

                      <div class="description-editor-container">
                        <ckeditor
                          [editor]="Editor"
                          [config]="editorConfig"
                          [(ngModel)]="tenantDetails.description"
                          formControlName="facilityDescriptionFormControl">
                        </ckeditor>
                      </div>
                    </div>
                  </div>
                    <div class="row">
                        <div class="col">
                            <div>
                                <p class="admin-string-primary" style="margin-top: 25px;">
                                    ADDRESS
                                </p>
                                <hr style="background-color: #D8DFE6;" />
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div>
                                        <div style="float: left;margin-right: 100px;">
                                            <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="address-line-1">
                                                AREA/LANDMARK
                                            </label>
                                            <input type="text" id="address-line-1" [(ngModel)]="tenantDetails.address.addressLine1" formControlName="addressLine1FormControl" class="form-control" placeholder="Address Line 1"
                                                style="width: 350px;height: 40px;" />
                                            </div>
                                        <div style="float: left;">
                                            <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="address-line-2">
                                                ADDRESS
                                            </label>
                                            <input type="text" id="address-line-2" [(ngModel)]="tenantDetails.address.addressLine2" formControlName="addressLine2FormControl" class="form-control" placeholder="Address Line 2"
                                                style="width: 350px;height: 40px;" />
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div style="margin-top: 20px;">
                                        <div style="float: left;margin-right: 100px;">
                                            <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="city">
                                                CITY
                                            </label>
                                            <select [(ngModel)]="tenantDetails.address.city" id="city" class="form-control" formControlName="cityFormControl" (change)="selectValueChangeForCity()" style="width: 350px;height: 40px;" required>
                                                <!-- <option value="" hidden>
                                                        Facility Type
                                                </option> -->
                                                <option *ngFor="let city of cities" [value]="city">
                                                        {{city}}
                                                </option>
                                            </select>
                                        </div>
                                        <div style="float: left;">
                                            <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="pincode">
                                                PINCODE
                                            </label>
                                            <input type="text" id="pincode" [(ngModel)]="tenantDetails.address.pinCode" formControlName="pincodeFormControl" class="form-control" placeholder="Pincode"
                                                style="width: 350px;height: 40px;" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div>
                                <p class="admin-string-primary" style="margin-top: 25px;">
                                    CONTACT DETAILS
                                </p>
                                <hr style="background-color: #D8DFE6;" />
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div>
                                        <div style="float: left;margin-right: 100px;">
                                            <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="phone-number-1">
                                                PHONE NUMBER 1
                                            </label>
                                            <input type="text" id="phone-number-1" [(ngModel)]="tenantDetails.contactPhoneNumber1" formControlName="phoneNumber1FormControl" class="form-control" placeholder="Phone Number 1"
                                                style="width: 350px;height: 40px;" />
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber1FormControl.hasError('required') && facilityDetailsFormControls.phoneNumber1FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number is required.
                                            </div>
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber1FormControl.hasError('pattern') && facilityDetailsFormControls.phoneNumber1FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number must be in digits.
                                            </div>
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber1FormControl.hasError('minlength') && facilityDetailsFormControls.phoneNumber1FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number must be at least 10 digits.
                                            </div>
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber1FormControl.hasError('maxlength') && facilityDetailsFormControls.phoneNumber1FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number must be at most 10 digits.
                                            </div>
                                            </div>
                                        <div style="float: left;">
                                            <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="phone-number-2">
                                                PHONE NUMBER 2
                                            </label>
                                            <input type="text" id="phone-number-2" [(ngModel)]="tenantDetails.contactPhoneNumber2" formControlName="phoneNumber2FormControl" class="form-control" placeholder="Phone Number 2"
                                                style="width: 350px;height: 40px;" />
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber2FormControl.hasError('pattern') && facilityDetailsFormControls.phoneNumber2FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number must be in digits.
                                            </div>
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber2FormControl.hasError('minlength') && facilityDetailsFormControls.phoneNumber2FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number must be at least 10 digits.
                                            </div>
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber2FormControl.hasError('maxlength') && facilityDetailsFormControls.phoneNumber2FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number must be at most 10 digits.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div style="margin-top: 20px;">
                                        <div style="float: left;margin-right: 100px;">
                                            <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="phone-number-3">
                                                PHONE NUMBER 3
                                            </label>
                                            <input type="text" id="phone-number-3" [(ngModel)]="tenantDetails.contactPhoneNumber3" formControlName="phoneNumber3FormControl" class="form-control" placeholder="Phone Number 3"
                                                style="width: 350px;height: 40px;" />
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber3FormControl.hasError('pattern') && facilityDetailsFormControls.phoneNumber3FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number must be in digits.
                                            </div>
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber3FormControl.hasError('minlength') && facilityDetailsFormControls.phoneNumber3FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number must be at least 10 digits.
                                            </div>
                                            <div *ngIf="facilityDetailsFormControls.phoneNumber3FormControl.hasError('maxlength') && facilityDetailsFormControls.phoneNumber3FormControl.touched" style="color: red;font-size: 14px;">
                                                    Phone Number must be at most 10 digits.
                                            </div>
                                            </div>
                                            <!-- Email -->
                                            <div style="margin-top: 10px;">
                                            <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;">
                                                EMAIL <span style="color:red;">*</span>
                                            </label>
                                            <input type="text" id="email" [(ngModel)]="tenantDetails.email" formControlName="emailFormControl" class="form-control" placeholder="e.g. a@b.com, c@d.com"
                                                style="width: 350px;height: 40px;" />
                                            <div *ngIf="facilityDetailsFormControls.emailFormControl.hasError('pattern') && facilityDetailsFormControls.emailFormControl.touched" style="color: red;font-size: 14px;">
                                                Enter valid email(s), comma-separated.
                                            </div>
                                            <div *ngIf="facilityDetailsFormControls.emailFormControl.hasError('required') && facilityDetailsFormControls.emailFormControl.touched" style="color: red;font-size: 14px;">
                                                Email is required.
                                            </div>
                                            </div>
                                        <!-- <div style="float: left;">
                                            <label style="font-size: 11px;height: 15px;padding-top: 0px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" for="address-line-2">
                                                Phone Number 1
                                            </label>
                                            <input type="text" id="address-line-2" [(ngModel)]="tenantDetails.address.addressLine2" formControlName="addressLine2FormControl" class="form-control" placeholder="Address Line 2"
                                                style="width: 350px;height: 40px;" />
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div>
                                <p class="admin-string-primary" style="margin-top: 25px;">
                                    PHOTOS
                                </p>
                                <p style="font-size: 13px; color: #7c7575; margin-bottom: 10px;">
                                  Select the radio button below an image to make it the default image.
                                  The selected image will be displayed first across the website. You can upload a maximum of 5 images.
                                </p>
                                <hr style="background-color: #D8DFE6;" />
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="clearfix">
                                        <div *ngFor="let image of images; let i = index">
                                          <div class="img-container" style="text-align:center;">
                                            <div class="image-preview-container">
                                              <img [src]="image" class="uploaded-image">
                                            </div>
                                                <!-- <mat-radio-button [value]="i" [ngModelOptions]="{standalone: true}" [(ngModel)]="defaultImageIndex" (click)="selectDefaultImageIndex(i)" class="example-radio-button" style="margin-top: 20px;"
                                                [color]= "radioButtonColor">
                                                </mat-radio-button> -->
                                                <input required id="image{{i}}" [value]='i' type="radio" [ngModel]="defaultImageIndex" (ngModelChange)="defaultImageIndexChange($event)" [ngModelOptions]="{standalone: true}" />
                                                <mat-icon title="Delete image" *ngIf="images.length>1" class="rule-icon" style="margin-left: 10px;" (click)="confirmDeleteImage(image)">delete</mat-icon>
                                            </div>
                                        </div>
                                        <div class="popup-overlay" *ngIf="showDeleteImagePopup">
                                            <div class="confirmation-popup">
                                              <p>You cannot recover the images after the delete operation. Do you want to proceed?</p>
                                              <button (click)="deleteImage()">Yes</button>
                                              <button (click)="closeImagePopup()" style ="margin-left:20px;">No</button>
                                            </div>
                                        </div>
                                        <div *ngFor="let image of previewImages; let i = index">
                                            <div class="img-container" style="text-align: center;">
                                              <div class="image-preview-container">
                                                <img [src]="image.dataUrl" class="uploaded-image">
                                              </div>
                                                <!-- <mat-radio-button [value]="i" [ngModelOptions]="{standalone: true}" [(ngModel)]="defaultImageIndex" (click)="selectDefaultImageIndex(i)" class="example-radio-button" style="margin-top: 20px;"
                                                [color]= "radioButtonColor">
                                                </mat-radio-button> -->
                                                <input required id="image{{i}}" [value]='i + images.length' type="radio" [ngModel]="defaultImageIndex" (ngModelChange)="defaultImageIndexChange($event)" [ngModelOptions]="{standalone: true}" />
                                            </div>
                                        </div>
                                      <div
                                        *ngIf="images.length + previewImages.length < 5"
                                        class="upload-image-container"
                                        (click)="fileInput.click()">

                                        <input #fileInput
                                               accept="image/jpg, image/jpeg, image/png, image/svg"
                                               (change)="onFileUploaded($event)"
                                               type="file"
                                               style="display:none">

                                        <div>
                                          <img src="../../assets/img/file-upload-icon.jpg"
                                               style="width:50px;height:50px;">
                                        </div>

                                        Upload Image
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
